import {
  START_LOADING_ADMIN_SETTINGS,
  ADMIN_SETTINGS_LOAD_SUCCESS,
  ADMIN_SETTINGS_LOAD_FAILED,
  ADMIN_SETTINGS_UPDATE_SUCCESS,
  ADMIN_SETTINGS_ALL_LOADED
} from '../actions/types';

const initialState = {
  loadingAdminSettings: false,
  adminSettings: null, // 通用預設分頁（含 Excel 密碼）
  adminSettingsList: [], // 全部分頁（通用 + 各部門）
};

// 把更新回傳的分頁合併回 list（meta.docId: 'global' 或文件 _id）
const mergeIntoList = (list, doc, docId) => {
  if (!docId || docId === 'global') {
    return list;
  }
  const idx = list.findIndex(d => String(d._id) === String(docId));
  if (idx < 0) return [...list, doc];
  const next = [...list];
  next[idx] = doc;
  return next;
};

export default (state = initialState, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case START_LOADING_ADMIN_SETTINGS:
      return {
        ...state,
        loadingAdminSettings: true
      };
    case ADMIN_SETTINGS_LOAD_SUCCESS:
      return {
        ...state,
        loadingAdminSettings: false,
        adminSettings: { ...payload }
      };
    case ADMIN_SETTINGS_ALL_LOADED:
      return {
        ...state,
        adminSettingsList: [...payload]
      };
    case ADMIN_SETTINGS_LOAD_FAILED:
      return {
        ...state,
        loadingAdminSettings: false
      };
    case ADMIN_SETTINGS_UPDATE_SUCCESS:
      return {
        ...state,
        // 更新通用分頁 → 同步 adminSettings（含 Excel 密碼）
        adminSettings:
          !meta || !meta.docId || meta.docId === 'global'
            ? { ...payload }
            : state.adminSettings,
        // 更新指定分頁 → 合併進 list
        adminSettingsList:
          !meta || !meta.docId || meta.docId === 'global'
            ? state.adminSettingsList
            : mergeIntoList(state.adminSettingsList, payload, meta.docId),
      };
    default:
      return state;
  }
};
